import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendContinuousOptimizationInstruction,
  BackendQueryContinuousOptimizationInstructionArgs,
} from 'src/types/backend';

const QUERY = gql`
  query ContinuousOptimizationInstruction($campaignId: ID!) {
    continuousOptimizationInstruction(campaignId: $campaignId) {
      jsSnippet
    }
  }
`;

type Variables = BackendQueryContinuousOptimizationInstructionArgs;
type Result = BackendContinuousOptimizationInstruction;

export const queryCOInstruction = async (variables: Variables) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
